import { render, staticRenderFns } from "./manage-calculation.vue?vue&type=template&id=52e823e8&scoped=true&"
import script from "./manage-calculation.vue?vue&type=script&lang=ts&"
export * from "./manage-calculation.vue?vue&type=script&lang=ts&"
import style0 from "./manage-calculation.vue?vue&type=style&index=0&id=52e823e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e823e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VForm,VIcon,VSpacer})
